interface ConditionalRenderProps {
  condition: boolean;
}

const ConditionalRender = ({ condition, children }: React.PropsWithChildren<ConditionalRenderProps>) => {
  return condition ? children : null;
};

export default ConditionalRender;
